import { useDeferredValue, useEffect, useState } from 'react';
import { Col, Checkbox, Flex, Row, Form } from 'antd';
import { MCheckbox, MInput } from '@Components/Base';
import { FormikProps } from 'formik';
import { validateCheckboxSearchValue } from '@Utils/searchValidator';

type MCheckboxGroupProps<T> = {
  formik: FormikProps<T>;
  formikValue: Array<string>;
  formikValueName: string;
  itemTypes: Array<string>;
  showSearch?: boolean;
};

const CheckboxGroup = Checkbox.Group;

const MCheckboxGroup = <T,>(props: MCheckboxGroupProps<T>): JSX.Element => {
  const { formik, formikValue, formikValueName, itemTypes, showSearch } = props;
  const [searchError, setSearchError] = useState<string | null>(null);
  const [checkedList, setCheckedList] = useState<string[]>(formikValue);
  const [optionStatuses, setOptionStatuses] = useState<string[]>(itemTypes);
  const [searchValue, setSearchValue] = useState('');
  const deferredValue = useDeferredValue(searchValue);
  const checkAll = itemTypes?.length === checkedList?.length;

  useEffect(() => {
    setCheckedList(formikValue);
  }, [formikValue]);

  useEffect(() => {
    setOptionStatuses(
      itemTypes.filter((status) =>
        status.toLowerCase().includes(deferredValue.toLowerCase())
      )
    );
  }, [deferredValue, itemTypes]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = event.target;

    if (value) {
      setSearchValue(value);

      const error = validateCheckboxSearchValue(value);
      setSearchError(error);
    } else {
      setCheckedList([]);
      setOptionStatuses(itemTypes);

      setSearchError(null);
    }
  };

  return (
    <Row>
      <Col span={24}>
        <Flex vertical wrap="nowrap" className="mfilter-checkbox-container">
          {showSearch && (
            <Form.Item
              validateStatus={searchError ? 'error' : ''}
              help={searchError}
            >
              <MInput
                placeholder="Search..."
                onChange={handleChange}
                searchInput
              />
            </Form.Item>
          )}

          <MCheckbox
            onChange={(e) => {
              setCheckedList(e.target.checked ? itemTypes : []);
              formik.setFieldValue(
                formikValueName,
                e.target.checked ? itemTypes : []
              );
            }}
            checked={checkAll}
          >
            Select all
          </MCheckbox>
          <CheckboxGroup
            className="mfilter-checkbox-group trojan-checkbox"
            name={formikValueName}
            options={showSearch ? optionStatuses : itemTypes}
            value={checkedList}
            onChange={(value) => {
              setCheckedList(value);
              formik.setFieldValue(formikValueName, value);
            }}
          />
        </Flex>
      </Col>
    </Row>
  );
};

export default MCheckboxGroup;
